import { TabPanel, TabView } from "primereact/tabview"
import { DataUploadComponent } from "../DataUploadComponent/DataUploadComponent"
import { useEffect, useState } from "react"
import ComponentHeader from "../../pages/ComponentHeader";
import { DataNoticeComponent } from "../DataNoticeComponent/DataNoticeComponent";
import "./DataImportNoticeComponent.scss"
import { useNavigate, useParams } from "react-router";
import { useAppContext } from "../../Context";

export const DataImportNoticeComponent = ()=>{

    const navigate = useNavigate();
    const { tab } = useParams();
    const [activeIndex, setActiveIndex] = useState(0);
    const { providerType: contextProviderType, reviewYear: contextReviewYear } = useAppContext();
    const [localProviderType, setLocalProviderType] = useState<string>(contextProviderType);
    const [localReviewYear, setLocalReviewYear] = useState<number | undefined>(contextReviewYear);

    const handleProviderTypeChange = (providerType: string) => {
        setLocalReviewYear(undefined);
        setLocalProviderType(providerType);
    };

    const breadcrumbsTemplate = (item:any, options:any) => {
        return (<a className={options.className} style={{ cursor: 'pointer' }} onClick={() => setActiveIndex(item.index)}><span className={options.labelClassName}>{item.label}</span></a>)
    };
    const dataUploadItems = [{ label: 'Upload Center',template:breadcrumbsTemplate,index:0,path:''}]
    const noticeItems = [{ label: 'Provider Data & Notices',template:breadcrumbsTemplate,index:1,path:''}]

    useEffect(() => {
        if (tab === "notice") setActiveIndex(1);
        else if( tab === "import") setActiveIndex(0);
        else navigate("/")
    }, [tab]);

    return<>
    <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
        <header style={{ padding: '5px 5px 5px 5px', fontSize: '25px' }}>
                <strong>Data Upload and Notice Center</strong>
        </header>
        <div style={{marginTop:'10px'}}>
                <TabView
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                        if (e.index === 1) {
                            navigate("/dataupload/notice");
                        } else {
                            navigate("/dataupload/import");
                        }
                    }}
                >
                    <TabPanel header='Upload Center'>
                        <ComponentHeader breadcrumbs={dataUploadItems} hideProviderTypeDropdown providerType={localProviderType} reviewYear={localReviewYear} onProviderTypeChange={handleProviderTypeChange} onReviewYearChange={setLocalReviewYear}/>
                        <DataUploadComponent providerType={localProviderType} reviewYear={localReviewYear} onChangeProviderType={handleProviderTypeChange}></DataUploadComponent>
                    </TabPanel>
                    <TabPanel header='Data & Notice Center'>
                        <ComponentHeader breadcrumbs={noticeItems} providerType={localProviderType} onProviderTypeChange={handleProviderTypeChange} reviewYear={localReviewYear} onReviewYearChange={setLocalReviewYear} />
                        <DataNoticeComponent providerType={localProviderType} reviewYear={localReviewYear}></DataNoticeComponent>
                    </TabPanel>
                </TabView>
        </div>
    </div>
    </>
}